"use client";

import { signIn } from "next-auth/react";
import { Loader } from "@/app/components/Loaders";

const LoginForm = ({ setData, setOpen }) => {
  return (
    <div className="w-full mx-auto">
      <button
        onClick={() => signIn("azure-ad", { callbackUrl: "/hardware-audit" })}
        className="
        w-full 
        flex items-center gap-3
        justify-center
        cursor-pointer
        h-10 px-4
        border border-[#8C8C8C]
        bg-white text-[#5E5E5E]
        text-sm font-medium
        hover:bg-[#F5F5F5]
        active:bg-[#E5E5E5]
        focus:outline-none focus:ring-2 focus:ring-[#0078D4] focus:ring-offset-2
      "
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <rect x="1" y="1" width="10" height="10" fill="#F25022" />
          <rect x="13" y="1" width="10" height="10" fill="#7FBA00" />
          <rect x="1" y="13" width="10" height="10" fill="#00A4EF" />
          <rect x="13" y="13" width="10" height="10" fill="#FFB900" />
        </svg>

        <span>Sign in with Microsoft Test</span>
      </button>
    </div>
  );
};

export default LoginForm;
